import * as actions from '../actions'
import { combineReducers } from 'redux';

export function app(state = {}, action) {
  switch (action.type) {
    case actions.LOAD_APP_SETTINGS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state;
  }
}

export function modal(state = { modalType: null, modalProps: {}, modalContentProps: {} }, action) {
  switch (action.type) {
    case actions.MODAL_SHOW:
      return {
        ...state,
        modalType: action.payload.modalType,
        modalProps: action.payload.modalProps,
        modalContentProps: action.payload.modalContentProps
      }
    case actions.MODAL_HIDE:
      return {
        ...state,
        modalType: null,
        modalProps: {},
        modalContentProps: {}
      }
    default:
      return state;
  }
}

export function download(state = { path: '', packageId: '', fileId: '' }, action) {
  switch (action.type) {
    case actions.INITIATE_DOWNLOAD:
      return {
        ...state,
        path: action.payload.path,
        packageId: action.payload.packageId,
        fileId: action.payload.fileId
      }
    case actions.RESET_DOWNLOAD:
      return {
        ...state,
        path: '',
        packageId: '',
        fileId: ''
      }
    default:
      return state;
  }
}

export function user(state = {}, action) {
  switch (action.type) {
    case actions.LOAD_USER_DATA:
      localStorage.setItem('authType', action.payload.authType)
      return {
        ...action.payload
      }
    default:
      return state;
  }
}

export function portal(state = {}, action) {
  switch (action.type) {
    case actions.LOAD_PORTAL:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state;
  }
}

export function workingFolder(state = {}, action) {
  switch (action.type) {
    case actions.SET_WORKING_FOLDER:
      return {
        ...state,
        ...action.payload
      }
      case actions.CLEAR_WORKING_FOLDER:
        return {
          ...state,
          ...action.payload
        }
    default:
      return state;
  }
}

const contextMenuInitialState = {
  show: false,
  menuItems: [],
  coordinates: { x: 0, y: 0 },
}

export function contextMenu(state = contextMenuInitialState, action) {
  switch (action.type) {
    case actions.CONTEXT_MENU_SHOW:
      return {
        ...state,
        show: true,
        ...action.payload
      }
    case actions.CONTEXT_MENU_HIDE:
      return {
        ...contextMenuInitialState
      }
    default:
      return state;
  }
}

export const rootReducer = combineReducers({
  app,
  user,
  portal,
  modal,
  download,
  contextMenu,
  workingFolder,
});